import { render, staticRenderFns } from "./UiForm.vue?vue&type=template&id=3fe7cf81&scoped=true"
import script from "./UiForm.vue?vue&type=script&lang=js"
export * from "./UiForm.vue?vue&type=script&lang=js"
import style0 from "./UiForm.vue?vue&type=style&index=0&id=3fe7cf81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7cf81",
  null
  
)

export default component.exports